module.exports = __webpack_public_path__ + "img/img-poultry.3c75e9a0.svg";